import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { cohortColumnDefs, cohortDefaultColDef } from './definitions-config';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

function CohortTable({ rowData, editHandler }) {
  const ButtonRenderer = (params) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <IconButton onClick={() => editHandler(params.data)}>
          <EditIcon />
        </IconButton>
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };

  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: 16,
        border: '1px solid rgba(0,0,0,0.07)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
        overflow: 'hidden',
      }}
    >
      {/* Card header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          borderBottom: '1px solid #F3F4F6',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>
            Cohorts
          </span>
          <span
            style={{
              fontSize: 11.5,
              fontWeight: 600,
              color: '#6B7280',
              backgroundColor: '#F3F4F6',
              border: '1px solid #E5E7EB',
              borderRadius: '9999px',
              padding: '2px 10px',
            }}
          >
            {rowData?.length || 0} records
          </span>
        </div>
      </div>

      {/* AG Grid */}
      <div className='ag-theme-alpine' style={{ height: 520, width: '100%' }}>
        <AgGridReact
          columnDefs={cohortColumnDefs}
          defaultColDef={cohortDefaultColDef}
          rowData={rowData || []}
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={10}
          headerHeight={40}
          rowHeight={52}
          onGridReady={(params) => {
            params.api.sizeColumnsToFit();
          }}
          onGridSizeChanged={(params) => {
            params.api.sizeColumnsToFit();
          }}
          frameworkComponents={frameworkComponents}
        />
      </div>
    </div>
  );
}

export default CohortTable;
